import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { CssFeature } from '../types'

export const CssFeatureSymbol = createIdentifier<CssFeature<any>>(Symbol('CssFeatureSymbol'))
